/* esm.sh - react-remove-scroll@2.7.2 */
import r from"react-remove-scroll/dist/es2015/Combination";export{r as RemoveScroll};
//# sourceMappingURL=react-remove-scroll.mjs.map